module.exports = "/images/role-consultant-agency-icon.svg?9e68dd99f75035022b9776340ec64e7a";